import { IAIStrategy } from '../AIStrategy';
import { ITile, PipValue, BoardEnd, IBoardTile } from '../../core/types';
import { DominoRules } from '../../core/DominoRules';
import { pickRandom } from '../../utils/helpers';

/**
 * Easy AI Strategy: Picks a random playable tile.
 */
export class EasyStrategy implements IAIStrategy {
  name = 'easy';

  selectTile(hand: ITile[], leftEnd: PipValue | null, rightEnd: PipValue | null, boardTiles: IBoardTile[]): { tile: ITile; end: BoardEnd } | null {
    const playable = DominoRules.getPlayableTiles(hand, leftEnd, rightEnd);
    if (playable.length === 0) return null;

    const tile = pickRandom(playable);
    if (!tile) return null;

    const possibleEnds = DominoRules.getPlayableEnd(tile, leftEnd, rightEnd);
    const end = pickRandom(possibleEnds) || 'left';

    return { tile, end };
  }
}
